// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  html {
    scroll-behavior: smooth;
  }
  #root,
  .App {
    display: flex;
    flex-direction: column;
    height: 80vh !important;
  }
  body {
    margin: 0;
    padding: 0;
  }

  main {
    flex: 1 1;
    padding-top: 70px;
  }

  font-family: Arial, sans-serif;
  padding: 0;
  overflow-x: hidden;
  margin: 0;
}

.about123 {
  padding-top: 90px;
  padding-bottom: 0px;
}

.service123 {
  padding-top: 50px;
  padding-bottom: -40px;
}

.homologation123 {
  padding-top: 70px;
}
.dashboard123 {
  padding-top: 50%;
  padding-bottom: 70px;
}
.services123 {
  padding-top: 50%;
  padding-bottom: 70px;
}
.circular123 {
  padding: 0%;
  padding-bottom: 0%;
}
.ITNetworkFirst123 {
  padding: auto;
  padding-bottom: 0%;
}
.Navbar {
  top: 0;
  background-color: #fff;
  z-index: 10;

  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.Navbar {
  position: sticky;
}

.scrolling-buttons {
  position: absolute;
  bottom: 140px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
}

.scroll-btn {
  width: 30px;
  height: 30px;
  background-color: #90f011;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0.5;
}

.scroll-btn.active {
  background-color: #90f011;
  transform: scale(1.2);
  opacity: 1;
}

.scroll-btn:hover {
  background-color: #085521e3;
  transform: scale(1.2);
}

.scroll-btn:hover ~ .scroll-btn,
.scroll-btn:hover + .scroll-btn {
  opacity: 0.2;
}

.Footer {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  text-align: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE;IACE,uBAAuB;EACzB;EACA;;IAEE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,sBAAsB;EACtB,WAAW;;EAEX,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,WAAW;AACb","sourcesContent":["@import \"@fortawesome/fontawesome-free/css/all.min.css\";\n\n.App {\n  html {\n    scroll-behavior: smooth;\n  }\n  #root,\n  .App {\n    display: flex;\n    flex-direction: column;\n    height: 80vh !important;\n  }\n  body {\n    margin: 0;\n    padding: 0;\n  }\n\n  main {\n    flex: 1;\n    padding-top: 70px;\n  }\n\n  font-family: Arial, sans-serif;\n  padding: 0;\n  overflow-x: hidden;\n  margin: 0;\n}\n\n.about123 {\n  padding-top: 90px;\n  padding-bottom: 0px;\n}\n\n.service123 {\n  padding-top: 50px;\n  padding-bottom: -40px;\n}\n\n.homologation123 {\n  padding-top: 70px;\n}\n.dashboard123 {\n  padding-top: 50%;\n  padding-bottom: 70px;\n}\n.services123 {\n  padding-top: 50%;\n  padding-bottom: 70px;\n}\n.circular123 {\n  padding: 0%;\n  padding-bottom: 0%;\n}\n.ITNetworkFirst123 {\n  padding: auto;\n  padding-bottom: 0%;\n}\n.Navbar {\n  top: 0;\n  background-color: #fff;\n  z-index: 10;\n\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n.Navbar {\n  position: sticky;\n}\n\n.scrolling-buttons {\n  position: absolute;\n  bottom: 140px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 20px;\n}\n\n.scroll-btn {\n  width: 30px;\n  height: 30px;\n  background-color: #90f011;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  opacity: 0.5;\n}\n\n.scroll-btn.active {\n  background-color: #90f011;\n  transform: scale(1.2);\n  opacity: 1;\n}\n\n.scroll-btn:hover {\n  background-color: #085521e3;\n  transform: scale(1.2);\n}\n\n.scroll-btn:hover ~ .scroll-btn,\n.scroll-btn:hover + .scroll-btn {\n  opacity: 0.2;\n}\n\n.Footer {\n  position: fixed;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 10;\n  text-align: center;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
